import { previewTypes } from 'shared/constants/preview-types';
import performance from 'shared/utils/performance';

import {
  getBuyButtonDisplayTypeWhenInOverlay,
  shouldShowSubscribeButton,
  shouldShowChannelCover,
  getPlayButtonType,
  BUY_BUTTON_DISPLAY_TYPES,
  PLAY_BUTTON_TYPES,
} from 'widget/utils/overlay-buttons-utils';


export function getTrailerTypeString(videoItem) {
  if (!videoItem) {
    return 'none';
  }

  let { trailerType } = videoItem;
  trailerType = trailerType || previewTypes.FIRST_20_SEC;

  switch (trailerType) {
    case previewTypes.FIRST_20_SEC:
      return 'preview';
    case previewTypes.TRAILER:
      return 'trailer';
    case previewTypes.NONE:
    default:
      return 'none';
  }
}

function getMainItemString(settings, showChannelCover) {
  return shouldShowChannelCover(settings, showChannelCover) ? 'channelCover' : 'featuredVid';
}

export function getPlayButtonTypeString(channelData, videoItem) {
  return getPlayButtonType(channelData, videoItem) === PLAY_BUTTON_TYPES.PLAY ?
    'playVid' :
    getTrailerTypeString(videoItem);
}

export function getOpenedEventParams(settings, channelData, videoItem, showChannelCover) {
  const playType = getPlayButtonType(channelData, videoItem);

  return {
    loading_time: performance.vars.appFullyRendered,
    buyTypeDisplayed: getBuyButtonDisplayTypeWhenInOverlay({
      settings,
      videoItem,
      channelData,
      showChannelCover,
    }),
    trailerType: getTrailerTypeString(videoItem),
    isTrailerBtn: playType === PLAY_BUTTON_TYPES.TRAILER_OR_PREVIEW,
    isSubscriptionBtn: shouldShowSubscribeButton({ settings, videoItem, channelData, showChannelCover }),
    mainItem: getMainItemString(settings, showChannelCover),
  };
}

export function getVideoSelectedEventParams({ appSettings, channelData, videoItem }) {
  const buyType = getBuyButtonDisplayTypeWhenInOverlay({
    settings: appSettings,
    videoItem,
    channelData,
    showChannelCover: false,
  });
  const playType = getPlayButtonType(channelData, videoItem);

  return {
    buyType,
    channelID: channelData.id,
    trailerType: getTrailerTypeString(videoItem),
    buyBtn: buyType === BUY_BUTTON_DISPLAY_TYPES.BUY,
    trailerBtn: playType === PLAY_BUTTON_TYPES.TRAILER_OR_PREVIEW,
    playBtn: playType === PLAY_BUTTON_TYPES.PLAY,
    videoID: videoItem.id,
  };
}



// WEBPACK FOOTER //
// ./src/shared/utils/bi/video-overlay-events-params.js